var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _path, _path2, _path3, _path4, _path5, _path6, _path7, _circle12, _circle13, _circle14, _circle15, _circle16, _circle17, _circle18, _circle19, _circle20, _circle21, _circle22;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgIconRocketWithStars = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
    className,
    height = 79,
    titleId,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 159 79",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: className,
    height: height,
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 133.154,
    cy: 23.5806,
    r: 1.58552,
    fill: "currentColor"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 157.426,
    cy: 31.5674,
    r: 0.937778,
    fill: "currentColor"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 0.937778,
    cy: 20.1728,
    r: 0.937778,
    fill: "currentColor"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 21.6784,
    cy: 56.1034,
    r: 0.937778,
    fill: "currentColor"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 47.9378,
    cy: 69.9378,
    r: 0.937778,
    fill: "currentColor"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 26.9378,
    cy: 6.93778,
    r: 0.937778,
    fill: "currentColor"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 110.846,
    cy: 3.72977,
    r: 0.937778,
    fill: "currentColor"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.23787,
    cy: 66.6604,
    r: 1.58552,
    fill: "currentColor"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 30.8489,
    cy: 31.8269,
    r: 3.80544,
    fill: "currentColor"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 136.082,
    cy: 55.9534,
    r: 2.58624,
    fill: "currentColor"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 114.938,
    cy: 44.9378,
    r: 0.937778,
    fill: "currentColor"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M96 70C101.223 70 103.5 67.949 103.5 63C103.5 67.949 105.761 70 111 70C105.761 70 103.5 72.1104 103.5 77C103.5 72.1104 101.223 70 96 70Z",
    stroke: "currentColor",
    strokeWidth: 2.5,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M87.9871 35.1289L82.6618 52.1694H72.3285L67.0033 35.1289C65.4849 30.2697 66.4493 24.9748 69.5834 20.9631L76.2738 12.3995C76.8943 11.6051 78.096 11.6051 78.7166 12.3995L85.4069 20.9631C88.541 24.9748 89.5053 30.2697 87.9871 35.1289Z",
    stroke: "currentColor",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M72.328 59.9194C72.328 65.0861 77.4947 67.6694 77.4947 67.6694C77.4947 67.6694 82.6613 65.0861 82.6613 59.9194",
    stroke: "currentColor",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M68.453 40.5441C59.4114 47.0024 64.578 57.3357 64.578 57.3357L72.328 52.1691",
    stroke: "currentColor",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M87.6508 40.5444C96.6924 47.0028 91.5258 57.3361 91.5258 57.3361L83.7758 52.1694",
    stroke: "currentColor",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M77.4947 36.6693C74.6411 36.6693 72.328 34.3562 72.328 31.5026C72.328 28.6491 74.6411 26.3359 77.4947 26.3359C80.3482 26.3359 82.6613 28.6491 82.6613 31.5026C82.6613 34.3562 80.3482 36.6693 77.4947 36.6693Z",
    stroke: "currentColor",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M50.0586 8.60209C54.5747 8.56126 56.5263 6.64343 56.4849 2.05856C56.5263 6.64343 58.4986 8.52579 63.0284 8.48484C58.4986 8.52579 56.5612 10.4986 56.6021 15.0284C56.5612 10.4986 54.5747 8.56126 50.0586 8.60209Z",
    stroke: "currentColor",
    strokeWidth: 2.5,
    strokeLinejoin: "round"
  })));
});
export const Icon = /*#__PURE__*/React.forwardRef((_ref2, ref) => {
  let {
    className: propClassName = "",
    fill = "none",
    stroke = "currentColor",
    weight = "normal",
    height = 79,
    titleId,
    title,
    ...props
  } = _ref2;
  const className = "vector-effect-non-scaling-stroke " + propClassName;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 159 79",
    fill: fill,
    xmlns: "http://www.w3.org/2000/svg",
    className: className,
    height: height,
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 133.154,
    cy: 23.5806,
    r: 1.58552,
    fill: "currentColor"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 157.426,
    cy: 31.5674,
    r: 0.937778,
    fill: "currentColor"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 0.937778,
    cy: 20.1728,
    r: 0.937778,
    fill: "currentColor"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 21.6784,
    cy: 56.1034,
    r: 0.937778,
    fill: "currentColor"
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 47.9378,
    cy: 69.9378,
    r: 0.937778,
    fill: "currentColor"
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: 26.9378,
    cy: 6.93778,
    r: 0.937778,
    fill: "currentColor"
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: 110.846,
    cy: 3.72977,
    r: 0.937778,
    fill: "currentColor"
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.23787,
    cy: 66.6604,
    r: 1.58552,
    fill: "currentColor"
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    cx: 30.8489,
    cy: 31.8269,
    r: 3.80544,
    fill: "currentColor"
  })), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    cx: 136.082,
    cy: 55.9534,
    r: 2.58624,
    fill: "currentColor"
  })), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    cx: 114.938,
    cy: 44.9378,
    r: 0.937778,
    fill: "currentColor"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M96 70C101.223 70 103.5 67.949 103.5 63C103.5 67.949 105.761 70 111 70C105.761 70 103.5 72.1104 103.5 77C103.5 72.1104 101.223 70 96 70Z",
    stroke: stroke,
    strokeWidth: 2.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.9871 35.1289L82.6618 52.1694H72.3285L67.0033 35.1289C65.4849 30.2697 66.4493 24.9748 69.5834 20.9631L76.2738 12.3995C76.8943 11.6051 78.096 11.6051 78.7166 12.3995L85.4069 20.9631C88.541 24.9748 89.5053 30.2697 87.9871 35.1289Z",
    stroke: stroke,
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.328 59.9194C72.328 65.0861 77.4947 67.6694 77.4947 67.6694C77.4947 67.6694 82.6613 65.0861 82.6613 59.9194",
    stroke: stroke,
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.453 40.5441C59.4114 47.0024 64.578 57.3357 64.578 57.3357L72.328 52.1691",
    stroke: stroke,
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.6508 40.5444C96.6924 47.0028 91.5258 57.3361 91.5258 57.3361L83.7758 52.1694",
    stroke: stroke,
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.4947 36.6693C74.6411 36.6693 72.328 34.3562 72.328 31.5026C72.328 28.6491 74.6411 26.3359 77.4947 26.3359C80.3482 26.3359 82.6613 28.6491 82.6613 31.5026C82.6613 34.3562 80.3482 36.6693 77.4947 36.6693Z",
    stroke: stroke,
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.0586 8.60209C54.5747 8.56126 56.5263 6.64343 56.4849 2.05856C56.5263 6.64343 58.4986 8.52579 63.0284 8.48484C58.4986 8.52579 56.5612 10.4986 56.6021 15.0284C56.5612 10.4986 54.5747 8.56126 50.0586 8.60209Z",
    stroke: stroke,
    strokeWidth: 2.5,
    strokeLinejoin: "round"
  }));
});
export default SvgIconRocketWithStars;
export const raw = __webpack_public_path__ + "static/media/icon-rocket-with-stars.3dc97ffc51c32c02695a17d805669178.svg";